import { render, staticRenderFns } from "./PrijemNDDodList.vue?vue&type=template&id=d7e15b86&"
import script from "./PrijemNDDodList.vue?vue&type=script&lang=ts&"
export * from "./PrijemNDDodList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports